import script from "./TimeOverModal.vue?vue&type=script&setup=true&lang=js"
export * from "./TimeOverModal.vue?vue&type=script&setup=true&lang=js"

import "./TimeOverModal.vue?vue&type=style&index=0&id=1bab7d2f&lang=css"

const __exports__ = script;

export default __exports__